import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useArtworksSldrCntx } from "../../context/artworksSldrCntx";
import { IArtwork } from "../../types/artwork/artwork";

import "./ImageList.scss";

interface IImageList {
  images: IArtwork[];
}

const ImageList: FC<IImageList> = ({ images }) => {
  const { setArtworks: setSldrAtrwrs } = useArtworksSldrCntx();

  const saveArtworks = (currentArtwork: IArtwork): void => {
    setSldrAtrwrs(
      images.map(el => {
        if (currentArtwork._id === el._id) {
          return { id: el._id, artwork: currentArtwork };
        }
        return { id: el._id, artwork: null };
      }),
    );
  };
  return (
    <div className="image_list">
      {images.map(artwork => {
        const { url } = artwork.image.medium || artwork.image.thumbnail || artwork.image.origin;
        return (
          <Link
            key={artwork._id}
            onClick={() => saveArtworks(artwork)}
            state={artwork}
            to={`/explore/artworks/${artwork._id}`}
          >
            <img src={url} alt={artwork._id} />
          </Link>
        );
      })}
    </div>
  );
};
export default ImageList;
